<app-user-account-list-node
    [accountTypes]="accountTypes"
    [selectedAccount]="selectedAccount"
    [loadAccount]="loadAccount"
    [allowSelectAccountType]="allowSelectAccountType"
    [isForeignCurrencyAccount]="isForeignCurrencyAccount"
    [level]="1"
    [maxLevel]="6"
    [hideClosedAccount]="hideClosedAccount"
    (addAccount)="composeAccount($event)"
    (deleteAccountFromList)="removeAccount()"
    [currency]="currency"
    (addAccountType)="composeAccountType($event)">
</app-user-account-list-node>